import { render, staticRenderFns } from "./CardLogs.vue?vue&type=template&id=c3e5483a&"
import script from "./CardLogs.vue?vue&type=script&lang=js&"
export * from "./CardLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports